import React from "react"
import config from "react-global-configuration"
import { parkingState } from "../../zustand/parkingState"
import MapOverviewElement from "./mapOverviewElement"

const MapOverview = ({ getClass }) => {
  const getOverviewElementData = (allProds, textKeys) => {
    let categoryNames = allProds.map((item) => item.product.categoryName)
    categoryNames = categoryNames.filter((name, index) => categoryNames.indexOf(name) === index)

    let overviewData = categoryNames.map((name) => {
      const color = allProds.find((element) => element?.product?.dynamicFields?.productColor && element?.product?.categoryName === name)?.product
        ?.dynamicFields?.productColor

      let carParks = allProds
        .filter((item) => {
          if (item?.product?.categoryName === name) return item
          return null
        })
        .map((item) => item.carPark.name)

      carParks = carParks.filter((carPark, index) => carParks.indexOf(carPark) === index)

      return {
        categoryName: name,
        color: color,
        carParks: carParks,
      }
    })

    let campaignProducts = allProds.filter(
      (item) =>
        (item.carPark.code !== "P4S" && item.product.categoryName !== "Medarbejdertilbud" && item.result.showPayOnFootPrice) ||
        (parkingState.getState().affiliateCode &&
          parkingState.getState().affiliateCode.toLowerCase() !== "hcp" &&
          parkingState.getState().affiliateCode.toLowerCase() !== "cpp" &&
          item.result.affiliateResult &&
          item.product.dynamicFields.affiliateBanner),
    )

    overviewData = [
      ...overviewData,
      ...campaignProducts.map((item) => {
        // dont show affiliateBanner if affiliateCode is HCP or CPP
        return {
          categoryName:
            parkingState.getState().affiliateCode &&
            parkingState.getState().affiliateCode.toLowerCase() !== "hcp" &&
            parkingState.getState().affiliateCode.toLowerCase() !== "cpp" &&
            item.product.dynamicFields.affiliateBanner
              ? item.product.dynamicFields.affiliateBanner
              : `${textKeys.campaign || "Kampagne"} ${item.carPark.code}`,
          color: "#fecb00",
        }
      }),
    ]
    if (parkingState.getState().globals.validPromotionCode) {
      overviewData = [...overviewData, { categoryName: parkingState.getState().globals.promotionName, color: "#fecb00" }]
    }

    // Remove duplicates
    overviewData = overviewData.filter((value, index) => {
      const _value = JSON.stringify(value)
      return (
        index ===
        overviewData.findIndex((obj) => {
          return JSON.stringify(obj) === _value
        })
      )
    })

    return overviewData
  }

  const textKeys = config.get("textKeys.parkingList.listElement")
  const { allProducts } = parkingState.getState()
  const isSoldOutProducts = allProducts.filter((item) => item.product.isSoldOut)

  return (
    <div className="parking-legend">
      <ul>
        {getOverviewElementData(allProducts, textKeys).map((element) => (
          <MapOverviewElement key={element.categoryName} categoryName={element.categoryName} color={element.color} getClass={getClass} />
        ))}
        {isSoldOutProducts && isSoldOutProducts.length > 0 ? (
          <li className="parking-legend__item parking-legend__item--soldout">
            <span className="icon">
              <span>P</span>
            </span>
            <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
          </li>
        ) : null}
      </ul>
    </div>
  )
}

export default MapOverview
